module.exports = "/images/Logo_AIW_dark.svg?8ffac0c7e55ab214556cae170b17d3b9";